module.exports = __webpack_public_path__ + "static/media/Absa-Digital-Proposition.3b0b7a0b.jpg";